module.exports = __webpack_public_path__ + "static/media/1.c7b8c425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4029/1.jpg
// module id = 668
// module chunks = 0